/**
 * @file Input component for emotions input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InputBase } from '../input-base/input-base';
/**
 * Class for the emotions input component
 */
var InputEmotionsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputEmotionsComponent, _super);
    function InputEmotionsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.valueOptions = [0, 1, 2, 3, 4, 5]; // (0 = unset)
        return _this;
    }
    /**
     * Set the value of the emotions input
     * @param newValue The new value of het emotions input
     */
    InputEmotionsComponent.prototype.setEmotion = function (newValue) {
        if (this.value !== newValue) {
            // Other value is clicked, so store this new value
            this.setValue(newValue);
        }
        else {
            // Same value is clicked, so reset value
            this.setValue(0);
        }
    };
    /**
     * Check if value exists
     */
    InputEmotionsComponent.prototype.hasEmotion = function () {
        return (this.value in this.valueOptions);
    };
    return InputEmotionsComponent;
}(InputBase));
export { InputEmotionsComponent };
